import algoliasearch from 'algoliasearch';

export function makeSearchClientWithKey(apiKey: string, appId: string) {
  return algoliasearch(appId, apiKey);
}

export function defaultAlgoliaContext(
  apiKey: string,
  appId: string,
  index: string
) {
  return {
    indexes: {
      main: index
    },
    searchClient: makeSearchClientWithKey(apiKey, appId)
  };
}
